import { Outlet } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Layout() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-100">
      <Navbar />
      <Outlet />
      <Footer />
    </div>
  );
}